<template>
  <div>
    <b-row class="m-0">
      <b-col
        :class="
          showDetails
            ? `col-12 col-sm-6 col-md-8 p-0 overflow`
            : `col-12 p-0 overflow`
        "
      >
        <div
          :class="active === index && 'h-100'"
          v-for="(file, index) in files"
          :key="index"
        >
          <div
            v-if="active === index"
            v-text="file.caption"
            class="py-3 text-center font-weight-bold"
          />
          <ContentPreview
            :file="file"
            :active="active"
            :indexFile="index"
            @move="move"
          />
          <div
            class="col-12 w-100 text-center files_count"
            v-if="index === active"
          >
            {{ $lang.page }} {{ fileNumber }} از {{ files.length }}
          </div>
        </div>
      </b-col>
      <b-col
        v-if="showDetails"
        :class="
          showDetails
            ? `col-12 col-sm-6  col-md-4 my-4 my-mt-4 b-strong-color`
            : `col-12 my-4 my-mt-4 b-strong-color`
        "
      >
        <div v-for="(file, index) in files" :key="index">
          <DetailsPreview
            :file="file"
            :active="active"
            :indexFile="index"
            :permissions="permissions"
            @removeFile="removeFile"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/**
 * @group filePriviewPage
 * این کامپوننت برای نمایش فایل  تعریف شده است
 */
import DetailsPreview from "./detailsPriview";
import ContentPreview from "./contentPriview";
export default {
  name: "file-priview-page", // نام کامپوننت
  components: {
    DetailsPreview,
    ContentPreview,
  },
  props: {
    // نمایش جزئیات
    showDetails: {
      type: Boolean,
      default: false,
    },
    // ارایه فایل هل
    files: {
      type: Array,
      default: () => [],
    },
    // جایگاه ابجکت انتخاب شده
    indexPriview: {
      type: Number,
      default: 0,
    },
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      slides: 0, // تعداد فایل‌ها
      active: this.indexPriview, // فایل انتخاب شده جایگاه
      fileNumber: null, // شماره فایل نمایش
    };
  },
  methods: {
    /**
     * @vuese
     * 	برای جابه جایی اسلایدر
     *  @arg  یارامتر ارسالی 1 به نام amount
     */
    move(amount) {
      let newActive;
      let newIndex = this.active + amount;
      if (this.files.length > newIndex) {
        if (amount == -1) this.active = this.slides - 1;
        if (newIndex >= 0) {
          if (newIndex > this.slides) newActive = 1;
          if (newIndex === 0) newActive = 0;
          this.active = newActive || newIndex;
          this.fileNumber = this.active + 1;
        }
        if (newActive == 1) {
          this.active = 0;
          this.fileNumber = this.active + 1;
        }
      } else {
        this.active = 0;
        this.fileNumber = this.active + 1;
      }
    },
    /**
     * @vuese
     * 	برای حذف فایل
     *  @arg  پارامتر آبجکت فایل
     */
    removeFile(file) {
      if (this.files.length == this.active + 1) this.active = this.active - 1;
      this.$emit("removeFile", file);
    },
  },
  async created() {
    this.fileNumber = this.active + 1;
    this.slides = this.files.length;
  },
};
</script>
<style lang="scss">
.files_count {
  position: absolute;
  bottom: 0;
  color: white;
  background: #00000099;
  font-size: 20px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.b-strong-color {
  color: black;
}

.overflow {
  overflow: hidden;
}
</style>
